import {
	Button,
	Col,
	Form,
	Input,
	Row,
	Select,
	Tag,
	notification,
	Checkbox,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";
import { userRoles } from "../../constants/User";

const EditUserPermission = ({ history, match }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [userList, setUserList] = useState([]);
	const [loadingForm, setLoadingForm] = useState(true);
	const [initialValues, setInitialValues] = useState({});
	const [allPermissions, setAllPermissions] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getAllPermissions();
		// getUserPermission();
	}, []);

	const getAllPermissions = async () => {
		const url = api + `/permission/get/all`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				console.log(data.payload);
				setAllPermissions(data.payload);
				getUserPermission();
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingForm(false);
		} catch (err) {
			const backendMessage =
				err.response && err.response.data && err.response.data
					? err.response.data
					: "Error while trying to get users";
			openNotification("error", "Error", backendMessage);
			console.error(err.message);
			return null;
		}
	};

	const getUserPermission = async () => {
		const url = api + `/user/get/permissions/${match.params.id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				const user = data.payload;

				setInitialValues({
					name: user.name,
					email: user.email,
					permissions: user.permissions || {},
				});

				form.setFieldsValue({
					name: user.name,
					email: user.email,
					permissions: user.permissions || {},
				});
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingForm(false);
		} catch (err) {
			const backendMessage =
				err.response && err.response.data && err.response.data
					? err.response.data
					: "Error while trying to get users";
			openNotification("error", "Error", backendMessage);
			console.error(err.message);
			return null;
		}
	};

	const updatePermission = async (data) => {
		setLoading(true);

		const permission = {
			permissions: data.permissions || {},
		};

		try {
			let url = api + `/permission/user/update/${match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.patch(url, permission);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					history.push("/permissions/user/list");
				}, 1000);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			setLoading(false);
			const backendMessage =
				err.response && err.response.data && err.response.data
					? err.response.data
					: "Error while trying to create permission";
			openNotification("error", "Error", backendMessage);
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		updatePermission(values);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Name" name="name">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Email" name="email">
							<Input size="large" disabled />
						</Form.Item>
					</Col>
					<Col span={24}>
						<Form.Item label="Permissions">
							<Row gutter={[16, 16]}>
								{allPermissions.map((permission) => (
									<Col span={6} key={permission.name}>
										<Form.Item
											name={["permissions", permission.name]}
											valuePropName="checked"
											noStyle
										>
											<Checkbox>
												{permission.name} ({permission.description})
											</Checkbox>
										</Form.Item>
									</Col>
								))}
							</Row>
						</Form.Item>
					</Col>
				</Row>
				<Button type="primary" htmlType="submit" loading={loading} size="large">
					Save
				</Button>
			</Form>
		);
	};

	return (
		<Layout
			title="Edit Permission"
			description="Edit existing Permission"
			type="medium"
		>
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default EditUserPermission;
